<template>
  <div class="result w-full bg-white px-4 py-6">
    <h1 class="font-semibold text-2xl mb-3">
      Kebijakan Privasi
    </h1>
    <p class="text-sm">Terima kasih telah menggunakan Aplikasi KaderKita. Privasi Anda penting bagi kami, dan kami berkomitmen untuk melindungi informasi pribadi yang Anda berikan. Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi data Anda.</p>

    <hr class="my-4 bg-[#979797] h-[2px]">

    <ol style="list-style-type: decimal;" class="font-semibold ms-4 text-lg">
      <li class="my-2">
        Informasi yang Kami Kumpulkan
        <ol class="ms-4 text-base list-[lower-alpha] my-2">
          <li class="sub-item">
            Informasi yang Diberikan oleh Pengguna
            <p class="font-normal my-2">
              Kami mengumpulkan jenis informasi berikut yang dimasukkan oleh kader kesehatan saat melakukan survei selama kegiatan Posyandu atau kunjungan rumah:
            </p>
            <ul class="list-disc ms-3">
              <li>
                Data Demografi:<span class="font-normal"> Nama, tanggal lahir, jenis kelamin, dan alamat warga dalam kategori sasaran berikut:</span>
                <ul class="list-[circle] ms-3 font-normal">
                  <li>Bayi & Balita</li>
                  <li>Ibu Hamil dan Ibu Bersalin / Ibu Menyusui</li>
                  <li>Remaja</li>
                  <li>Dewasa & Lansia</li>
                </ul>
              </li>
              <li>
                Data Kesehatan:<span class="font-normal"> Pengukuran kesehatan, tanggapan survei, dan pengamatan yang relevan dengan kategori tertentu.</span>
              </li>
            </ul>
          </li>
          <li class="sub-item">
            Informasi yang Dikumpulkan Secara Otomatis
            <p class="font-normal my-2">
              Saat menggunakan Aplikasi, kami dapat mengumpulkan data teknis tertentu secara otomatis, termasuk:
            </p>
            <ul class="ms-3 font-normal list-disc">
              <li>Informasi perangkat (misalnya, model, sistem operasi).</li>
              <li>Data log (misalnya, alamat IP, waktu akses).</li>
            </ul>
          </li>
        </ol>
      </li>
      <hr class="my-4 bg-[#979797] h-[2px] -ms-4">
      <li>
        Bagaimana Kami Menggunakan Informasi Anda
        <p class="font-normal my-2 text-base">
          Kami menggunakan informasi yang dikumpulkan untuk tujuan berikut:
        </p>
        <ol class="ms-4 text-base list-[lower-alpha] my-2">
          <li class="sub-item">
            Pemantauan Kesehatan: <span class="font-normal">Mendukung kegiatan pemantauan kesehatan dan menyediakan alat bagi kader untuk mengumpulkan dan mengelola data secara efektif.</span>
          </li>
          <li class="sub-item">
            Analisis Data: <span class="font-normal">Menganalisis dan meningkatkan inisiatif kesehatan masyarakat.</span>
          </li>
          <li class="sub-item">
            Kepatuhan: <span class="font-normal">Mematuhi kewajiban hukum terkait pengelolaan data kesehatan.</span>
          </li>
        </ol>
      </li>
      <hr class="my-4 bg-[#979797] h-[2px] -ms-4">
      <li>
        Berbagi dan Pengungkapan Data
        <p class="font-normal my-2 text-base">
          Kami tidak menjual atau menyewakan informasi pribadi Anda kepada pihak ketiga. Namun, kami dapat membagikan data Anda dalam keadaan berikut:
        </p>
        <ol class="ms-4 text-base list-[lower-alpha] my-2">
          <li class="sub-item">
            Dengan Otoritas Kesehatan: <span class="font-normal">Data dapat dibagikan dengan organisasi pemerintah atau kesehatan yang berwenang untuk inisiatif kesehatan masyarakat.</span>
          </li>
          <li class="sub-item">
            Penyedia Layanan: <span class="font-normal">Dengan penyedia layanan pihak ketiga terpercaya yang membantu dalam pengembangan dan pemeliharaan aplikasi.</span>
          </li>
          <li class="sub-item">
            Kewajiban Hukum: <span class="font-normal">Jika diwajibkan oleh hukum atau sebagai tanggapan atas proses hukum.</span>
          </li>
        </ol>
      </li>
      <hr class="my-4 bg-[#979797] h-[2px] -ms-4">
      <li>
        Keamanan Data
        <p class="font-normal my-2 text-base">
          Kami menerapkan langkah-langkah teknis dan organisasi yang sesuai untuk melindungi informasi Anda, termasuk:
        </p>
        <ol class="ms-4 text-base font-normal list-[lower-alpha] my-2">
          <li class="sub-item">
            Enkripsi data sensitif.
          </li>
          <li class="sub-item">
            Audit keamanan secara berkala.
          </li>
          <li class="sub-item">
            Akses data yang dibatasi berdasarkan peran dan tanggung jawab.
          </li>
        </ol>
        <p class="font-normal my-2 text-base">
          Namun, tidak ada sistem yang sepenuhnya aman. Kami mendorong kader untuk menggunakan kata sandi yang kuat dan perangkat yang aman saat menggunakan Aplikasi.
        </p>
      </li>
      <hr class="my-4 bg-[#979797] h-[2px] -ms-4">
      <li>
        Retensi Data
        <p class="font-normal my-2 text-base">
          Kami menyimpan informasi Anda hanya selama diperlukan untuk memenuhi tujuan yang diuraikan dalam Kebijakan Privasi ini atau sebagaimana diwajibkan oleh hukum. Setelah itu, data akan dihapus atau dianonimkan dengan aman.
        </p>
      </li>
      <hr class="my-4 bg-[#979797] h-[2px] -ms-4">
      <li>
        Hak Anda
        <p class="font-normal my-2 text-base">
          Anda memiliki hak-hak berikut terkait data Anda:
        </p>
        <ol class="ms-4 text-base list-[lower-alpha] my-2">
          <li class="sub-item">
            Akses: <span class="font-normal">Meminta akses ke informasi pribadi Anda.</span>
          </li>
          <li class="sub-item">
            Koreksi: <span class="font-normal">Meminta perbaikan data yang tidak akurat atau tidak lengkap.</span>
          </li>
          <li class="sub-item">
            Penghapusan: <span class="font-normal">Meminta penghapusan informasi pribadi Anda, tunduk pada kewajiban hukum.</span>
          </li>
          <li class="sub-item">
            Keberatan: <span class="font-normal">Menolak pemrosesan data Anda dalam kasus tertentu.</span>
          </li>
        </ol>
        <p class="font-normal my-2 text-base">
          Untuk menggunakan hak Anda, silakan hubungi kami di <b>ajs@rollingglory.com</b>.
        </p>
      </li>
      <hr class="my-4 bg-[#979797] h-[2px] -ms-4">
      <li>
        Privasi Anak-Anak
        <p class="font-normal my-2 text-base">
          Kami menyimpan informasi Anda hanya selama diperlukan untuk memenuhi tujuan yang diuraikan dalam Kebijakan Privasi ini atau sebagaimana diwajibkan oleh hukum. Setelah itu, data akan dihapus atau dianonimkan dengan aman.
        </p>
      </li>
      <hr class="my-4 bg-[#979797] h-[2px] -ms-4">
      <li>
        Pembaruan Kebijakan Privasi Ini
        <p class="font-normal my-2 text-base">
          Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu. Perubahan akan diberitahukan melalui Aplikasi atau email jika diperlukan. Kami mendorong pengguna untuk meninjau kebijakan ini secara berkala.
        </p>
      </li>
      <hr class="my-4 bg-[#979797] h-[2px] -ms-4">
      <li>
        Hubungi Kami
        <p class="font-normal my-2 text-base">
          Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini atau bagaimana data Anda ditangani, silakan hubungi kami di:
        </p>
        <ol class="ms-4 text-base list-[lower-alpha] my-2">
          <li class="sub-item">
            Email: ajs@rollingglory.com
          </li>
          <li class="sub-item">
            Telepon: +62 813-2229-2565
          </li>
          <li class="sub-item">
            Alamat: Jl. A. Yani No.261, Cihapit, Kec. Bandung Wetan, Kota Bandung, Jawa Barat 40114
          </li>
        </ol>
      </li>
      <hr class="my-4 bg-[#979797] h-[2px] -ms-4">
      <p class="font-normal my-2 text-base">
        Dengan menggunakan Aplikasi, Anda menyetujui ketentuan yang diuraikan dalam Kebijakan Privasi ini.
      </p>
    </ol>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('auth', ['errorMessage', 'errorStatus']),
  },
};
</script>

<style lang="scss">
// ol {
//   &>li.sub-item {
//     margin: 0.5rem 0;
//     &::marker {
//       content:"1." counter(list-item) " ";
//     }
//   }

//   &>li.sub-item-2 {
//     margin: 0.5rem 0;
//     &::marker {
//       content:"2." counter(list-item) " ";
//     }
//   }
// }
</style>
